/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
import TableCell from '@tiptap/extension-table-cell';
import { Plugin, PluginKey, NodeSelection } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { findParentNode } from '@tiptap/core';

export default TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        renderHTML: () => ({
          style:
            'border: 1px solid #84AFEF; text-align: left; padding: 5px; padding-right: 20px; position: relative; min-height: 31px;',
        }),
      },
    };
  },

  addProseMirrorPlugins() {
    const pluginKey = new PluginKey('table');
    const editorRef = this.editor;
    return [
      new Plugin({
        key: pluginKey,
        state: {
          init: () => ({ selectedCellPos: null }),
          apply(tr, value, oldState, newState) {
            const editorFocused = tr.getMeta('EDITOR_FOCUSED');
            if (editorFocused === false) return value;

            const { schema, selection } = newState;
            const {
              tableCell: schemaTableCell,
              tableHeader: schemaTableHeader,
            } = schema.nodes;
            const tableCell = findParentNode(
              ({ type }) =>
                type === schemaTableCell || type === schemaTableHeader
            )(selection);
            if (tableCell) {
              return { selectedCellPos: tableCell.start };
            }

            return { selectedCellPos: null };
          },
        },
        props: {
          decorations(state) {
            const { selectedCellPos } = this.getState(state);
            const decorations = [];
            if (selectedCellPos !== null) {
              const $pos = state.doc.resolve(selectedCellPos);
              const node = $pos.nodeAfter;
              const nodeParent = $pos.parent;
              if (
                (node && nodeParent.type.name === 'tableCell') ||
                nodeParent.type.name === 'tableHeader'
              ) {
                // Find the parent row
                const row = $pos.node(-1); // -1 indicates the parent node, which should be the row
                if (row && row.type.name === 'tableRow') {
                  // Loop through all cells in the row
                  row.forEach((cell, offset) => {
                    const cellStartPos = $pos.start(-1) + offset; // Position of the start of the cell
                    const cellEndPos = cellStartPos + cell.nodeSize; // Position of the end of the cell

                    // Add a Decoration to apply a class to each cell in the row
                    const cellDecor = Decoration.node(
                      cellStartPos,
                      cellEndPos,
                      {
                        class: 'selected-cell-decoration',
                      } // Custom class
                    );
                    decorations.push(cellDecor);
                  });
                }
              }

              if (
                (node && nodeParent.type.name === 'tableCell') ||
                nodeParent.type.name === 'tableHeader'
              ) {
                const cellEnd = $pos.end();
                const btnDecor = Decoration.widget(
                  cellEnd,
                  () => {
                    const btn = document.createElement('button');
                    btn.classList.add('optionButton');
                    const div1 = document.createElement('div');
                    const div2 = document.createElement('div');
                    const div3 = document.createElement('div');
                    div1.classList.add('optionDiv');
                    div2.classList.add('optionDiv');
                    div3.classList.add('optionDiv');
                    if (nodeParent.type.name === 'tableHeader') {
                      div1.style.backgroundColor = '#ffffff';
                      div2.style.backgroundColor = '#ffffff';
                      div3.style.backgroundColor = '#ffffff';
                    }
                    if (nodeParent.type.name === 'tableCell') {
                      div1.style.backgroundColor = '#272D55';
                      div2.style.backgroundColor = '#272D55';
                      div3.style.backgroundColor = '#272D55';
                    }
                    btn.append(div1, div2, div3);
                    btn.setAttribute('contentEditable', 'false');
                    btn.setAttribute('data-pos', selectedCellPos);
                    btn.classList.add('button-decoration');

                    btn.addEventListener('click', () => {
                      // Create a selection for the cell
                      const { tr } = state;
                      const cellPos = $pos.pos;

                      // Update the selection to the cell position
                      const newSelection = NodeSelection.create(
                        state.doc,
                        cellPos
                      );
                      editorRef.view.dispatch(tr.setSelection(newSelection));
                    });

                    return btn;
                  },
                  { key: 'button-decoration' }
                ); // Add a key for unique identification

                decorations.push(btnDecor);
              }
            }

            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});
